// extracted by mini-css-extract-plugin
export default {"workPage":"Work_workPage__t053u","banner":"Work_banner__NY-kE","overlay":"Work_overlay__JX7yk","content":"Work_content__zz0i-"};